import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';
import { PriceRenderer } from '@alfa-bank/site-invest-ui/components/renderer';
import { EMPTY_VALUE_TEXT } from '@alfa-bank/site-invest-emitents-common/constants';
import { getSymbolForPrice } from '@alfa-bank/site-invest-emitents-common/helpers';

import { defaultDividendBannerTexts } from '../../../configs';
import { getDividendsInfo } from '../../../helpers';
import type { IDividendCellProps } from '../models';
import styles from '../styles.css';

export const DividendValue: FC<IDividendCellProps> = ({ asset }) => {
    const { assetType, currencyObj } = asset;
    const { dividendValue } = getDividendsInfo(asset);

    if (!dividendValue) {
        return null;
    }

    const { title } = defaultDividendBannerTexts.cells.dividendValue;

    const symbol = getSymbolForPrice({ assetType: assetType.code, symbol: currencyObj.symbol });

    return (
        <>
            <Grid colAutoWidth collapse justify="start">
                <Text styler={{ margin: 0 }} view="accent-primary-medium">
                    <PriceRenderer
                        fallbackValue={EMPTY_VALUE_TEXT}
                        symbol={symbol}
                        value={dividendValue}
                    />
                </Text>
            </Grid>

            <Grid
                alignment="center"
                colAutoWidth
                collapse
                justify="start"
                styler={{ marginTop: 4 }}
            >
                <Text
                    className={cn(styles.external, styles.text)}
                    styler={{ margin: 0 }}
                    view="primary-small"
                >
                    {title}
                </Text>
            </Grid>
        </>
    );
};
